// Comment mode on/off, shared by the top bar's Feedback button and the feedback layer.
import { createStore } from "../store";

export const commentMode = createStore<boolean>(false);

export function toggleCommentMode() {
  commentMode.set((on) => !on);
}

/** Where the composer goes: a bottom sheet on phones, else next to the element, kept on screen. */
export function composerPosition(
  target: { left: number; top: number; right: number; bottom: number },
  viewport: { width: number; height: number },
  size: { width: number; height: number } = { width: 340, height: 260 },
): { kind: "sheet" } | { kind: "float"; left: number; top: number } {
  if (viewport.width < 640) return { kind: "sheet" };
  const gap = 8;
  const margin = 12;
  let top = target.bottom + gap;
  if (top + size.height > viewport.height - margin) top = target.top - gap - size.height;
  top = Math.min(Math.max(margin, top), Math.max(margin, viewport.height - size.height - margin));
  let left = target.left;
  left = Math.min(Math.max(margin, left), Math.max(margin, viewport.width - size.width - margin));
  return { kind: "float", left: Math.round(left), top: Math.round(top) };
}
